function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#EDEEF0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.64535 11.2783L9.89432 10.7527L9.06441 6.43718C8.81543 5.21998 9.11973 4.69436 10.0603 4.52838V4.52838H9.17506C8.92609 4.6667 8.37281 5.02633 8.67711 6.46485L9.64535 11.2783Z",
  fill: "#8EC089"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.14748 12.3296L9.39645 11.804L8.2899 6.43718C8.06859 5.38596 8.17925 4.86035 8.51121 4.55605V4.52838H7.90261C7.70896 4.91567 7.65363 5.30297 7.87494 6.35419L9.14748 12.3296Z",
  fill: "#E85F24"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.64956 13.3524L8.89853 12.8268L7.51534 6.29815C7.26637 5.27459 7.3217 4.83197 7.43235 4.5H6.90674C6.90674 5.05328 6.96207 5.60655 7.12805 6.13216L8.64956 13.3524Z",
  fill: "#1C4695"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.40877 4.52838H5.80017V4.55605C6.07681 4.88801 6.1598 5.30297 6.38111 6.21587L8.04094 13.9064H8.42823L6.7684 6.18821C6.60242 5.63493 6.49177 5.08166 6.40877 4.52838Z",
  fill: "#245ABC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.16393 4.52911H4.5V4.55678C5.1086 4.80575 5.4129 5.24837 5.66188 6.35492L7.29404 13.9348H7.68133L6.02151 6.27193C5.71721 4.94407 5.4129 4.6951 5.16393 4.52911Z",
  fill: "#318EEE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6566 4.52838C12.8543 4.971 12.3841 5.82858 11.4158 7.93103H11.4435C12.5777 5.80092 13.214 4.971 14.6802 4.52838V4.52838H13.6566Z",
  fill: "#1C4695"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3607 7.90336C12.3289 5.71792 12.5502 5.10932 12.9375 4.55605V4.52838H12.1906V4.55605C12.2736 5.41362 11.9693 6.21587 11.3607 7.90336Z",
  fill: "#E85F24"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3052 7.84732C11.9138 5.91085 12.1075 5.02561 11.5819 4.5H10.8626V4.52766C11.6925 4.83197 11.8585 5.66188 11.3052 7.84732Z",
  fill: "#8EC089"
});

function SvgVrbo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrbo);
export default __webpack_public_path__ + "static/media/vrbo.82a9b979.svg";
export { ForwardRef as ReactComponent };